import {Directive, OnInit, TemplateRef} from '@angular/core';
import { HeaderService } from '../../services/header/header.service';

@Directive({
  selector: '[breadcrumb]',
})
export class BreadcrumbDirective implements OnInit {
  constructor(private headerService: HeaderService, private ref: TemplateRef<any>) {}

  ngOnInit(): void {
    this.headerService.setContents(this.ref);
  }
}